<!--  -->
<template>
  <div class="headerNav">
    <div class="flexCenter">
      <img src="@/assets/Slice.png" alt="" />
      <div class="nav-items">
        <div
          v-for="(item, i) in navList"
          :key="i"
          @click="toDetail(item, i)"
          :class="[
            'nav-item',
            { active: identification == item.identification },
          ]"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div>
      <!-- <el-button type="text" class="buttonTxt" @click="register"
        >登录</el-button
      >
      <el-button type="primary" @click="register">免费注册</el-button> -->
      <div class="flex">
        <div class="buttonTxt" @click="customerService">客服</div>
        <div class="buttonTxt" @click="register" v-if="identification != 5">
          企业入驻
        </div>

        <div
          class="buttonTxt"
          @click="registerAnxinCloud"
          v-if="identification == 5"
        >
          登录安心云
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["identification"],
  data() {
    return {
      navList: [
        {
          name: "首页",
          identification: 0,
          image: "",
        },
        {
          name: "安心云",
          identification: 5,
        },
        {
          name: "产品服务",
          identification: 1,
        },
        {
          name: "解决方案",
          identification: 2,
        },
        {
          name: "关于我们",
          identification: 3,
        },
        {
          name: "合伙人",
          identification: 4,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},

  methods: {
    toDetail(item) {
      // this.identification = item.identification;
      this.$emit("toDetail", item.identification);
    },
    register() {
      window.open("https://web.minjiangyouyue.com/");
    },
    registerAnxinCloud() {
      window.open("https://axy.minjiangyouyue.com/");
    },
    customerService() {
      window.open("https://1811001.s2.udesk.cn/im_client/?web_plugin_id=65762");
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.headerNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
  .flexCenter {
    display: flex;
  }
  img {
    width: 114px;
    height: 40px;
    margin-right: 15px;
  }
}
.nav-items {
  display: flex;
  align-items: center;
  .nav-item {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #141414;
    margin-left: 40px;
    cursor: pointer;
  }
}
.buttonTxt {
  font-weight: 500;
  font-size: 14px;
  color: #030303;
  margin-right: 30px;
  cursor: pointer;
}
.active {
  font-weight: bold !important;
  font-size: 14px !important;
  color: #1c87ff !important;
  position: relative;
}

.active::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 25%;
  width: 50%;
  border-radius: 50px;
  height: 3px;
  background-color: #1c87ff;
}
@media (max-width: 750px) {
  .nav-item {
    font-size: 24px !important;
  }
  .active {
    font-size: 24px !important;
  }
  .headerNav {
    img {
      width: 84px;
      margin-right: 0;
    }
  }
  .buttonTxt {
    margin-right: 0;
    font-size: 22px;
    color: #fff;
    background: #1c87ff;
    padding: 15px 15px;
    border-radius: 20px;
  }
}
.flex {
  display: flex;
}
</style>
